import { Component, OnInit } from '@angular/core';
import { Bando } from '../../models/bando';
import { Router } from '@angular/router';
import { LoaderService } from '../../service/loader.service';
import { RestService } from '../../service/rest.service';
import { Message } from '../../service/message.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styles: [],
  standalone: false,
 
})

export class ProfileComponent implements OnInit {
  constructor(private router: Router, private rest: RestService, private loader: LoaderService,private message:Message) { }
 completeData: any = {
    fatturatiUltimiTreAnni: [{}, {}, {}],
    sedi: [],
    ateco:[],
    ragioneSociale:''
  }
  email: string = ""
  role = 0;
  outlookAccessToken = null;
  myPlan:any
  showPassword = false
  oldPassword = ''
  newPassword = ''
  confirmNewPassword = ''

  ngOnInit(): void {
    const url = new URL(window.location.href);
    this.loader.on()
    const params = url.searchParams;
    this.rest.get('/user/me').subscribe({
      next: (value: any) => {
        let dataForProfile = value.profile
        this.email = value.email;
        if(!dataForProfile){
          dataForProfile = {}
        }
        if(!dataForProfile.fatturatiUltimiTreAnni){
          dataForProfile.fatturatiUltimiTreAnni = [{}, {}, {}]
        }
        if(!dataForProfile.sedi){
          dataForProfile.sedi = []
        }
        if(!dataForProfile.ateco){
          dataForProfile.ateco = []
        }
        this.completeData = {
          ...(value.profile || {}),
          firstName: value.firstName || value.profile?.firstName || '',
          lastName: value.lastName || value.profile?.lastName || ''
        };
        this.role = value.role;
        this.outlookAccessToken = value.outlookAccessToken;
        if (value.planId) {
          this.rest.get(`/plan?options={%22page%22:1,%22filters%22:[{%22s%22:%22id%22,%22v%22:%22${value.planId}%22,%22o%22:1}]}`).subscribe({
            next: (value:any) => {
              this.myPlan = value.data[0]
              this.loader.off(true)
            },
            error: () => {
              this.loader.off(true)
            }
          })
        } else {
          this.loader.off(true)
        }
      },
    })
  }

  confirmChangePassword() {
    if(this.newPassword == this.confirmNewPassword){
    this.loader.on(true)
    this.showPassword = false
    this.rest.patch('/auth/change-password', {
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
      newPasswordConfirm: this.confirmNewPassword
    }).subscribe({
      next: (value: any) => {
        this.loader.off(true)
        this.message.showMessage('Password modificata', 'success')
      },
      error: (value: any) => {
        this.message.showMessage('Errore nella modifica', 'error')
        this.loader.off(true)
      },
    })}else{
      this.message.showMessage('Le due password non coincidono', 'error')
    }
  }

  removeSede(index: number) {
    this.completeData.sedi.splice(index, 1);
  }

  removeAteco(index: number) {
    this.completeData.ateco.splice(index, 1);
  }

  sedeType(value: any, index: number) {
    this.completeData.sedi[index].tipo = value.element
  }

  atecoType(value: any, index: number) {
    this.completeData.ateco[index].tipo = value.element
  }

  confirmData() {
     this.completeData.numeroDipendenti = parseInt(this.completeData?.numeroDipendenti)
     if(this.completeData?.fatturatiUltimiTreAnni){
    this.completeData.fatturatiUltimiTreAnni.forEach((fatturato:any) => {
     if(fatturato.anno){
      fatturato.anno = parseFloat(fatturato.anno)
     }
     if(fatturato.valore){
      fatturato.valore = parseFloat(fatturato.valore)
     }
    });}
     this.loader.on()
     this.rest.patch('/user/update/profile',this.completeData).subscribe({
       next:(value:any)=> {
         this.loader.off(true)
         this.message.showMessage('Profilo modificato','success')
       },
             error:(value:any)=> {
              this.message.showMessage('Errore nella modifica,devi compilare tutti i campi','error')
         this.loader.off(true)
       },
     })
  }

  connectOutlook() {
     this.loader.on()
     this.rest.get('/user/outlook/connect-url').subscribe({
       next:(value:any)=> {
         this.loader.off(true);
         if(value.url) {
          window.location.href = value.url;
         }
       },
        error:(value:any)=> {
        this.message.showMessage('Errore nel collegamento','error')
         this.loader.off(true)
       },
     })
  }

  disconnectOutlook() {
     this.loader.on()
     this.rest.delete('/user/outlook/connect').subscribe({
       next:(value:any)=> {
         this.loader.off(true);
          window.location.href = "/profilo";
       },
        error:(value:any)=> {
        this.message.showMessage('Errore nel collegamento','error')
         this.loader.off(true)
       },
     })
  }
}
